import { useEffect, useState } from "react";
import api from "@/lib/api";

// Which data profile the backend runs: "real", "demo" or "test". Fetched once per page load.
let cached = null;
let pending = null;

export default function useProfile() {
  const [profile, setProfile] = useState(cached);
  useEffect(() => {
    if (cached) return;
    pending = pending || api.get("/").then(({ data }) => (cached = data.profile || null)).catch(() => null);
    pending.then((p) => p && setProfile(p));
  }, []);
  return profile;
}
